import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=6378aefa&scoped=true&"
import script from "./Goods.vue?vue&type=script&lang=js&"
export * from "./Goods.vue?vue&type=script&lang=js&"
import style0 from "./Goods.vue?vue&type=style&index=0&id=6378aefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378aefa",
  null
  
)

export default component.exports